import React from 'react';
import { words } from 'lodash';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import "./styles.scss";

const WorkspaceBanner = props => {
  const { height, isMobile } = useViewport();
  if (!props.data) {
    return null;
  }

  const {
    title,
    description,
    description_mobile,
    image,
    image_mobile,
    thumbnail,
    thumbnail_mobile,
    banner_video,
  } = props.data;
  let className = 'workspace-banner';
  let imageUrl = image;
  let thumbNail = thumbnail;
  let countLengthOf = StringUtil.sliceHtml(description);
  const length = words(countLengthOf).length;
  const mobile_description = StringUtil.sliceHtml(description_mobile);

  const renderDescription = () => {
    if (isMobile) {
      return <h4 className={'description-mobile'}>{mobile_description}</h4>;
    }
    return (
      <HTMLView
        className={'workspace-banner-description'}
        html={description}
        tagName={'div'}
      />
    );
  };

  const renderBannerTextMobile = () => {
    return (
      <div className={'banner-text'}>
        <h1>{title}</h1>
        {renderDescription()}
      </div>
    );
  };

  let bannerText = title;
  if (isMobile) {
    imageUrl = image_mobile;
    thumbNail = thumbnail_mobile;
    bannerText = renderBannerTextMobile();
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'workspace-banner-image'}
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        title={bannerText}
        length={length}
        description={renderDescription()}
        descriptionClass={'workspace-banner-description'}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {/*<FooterExploreButton theme={theme} onClick={handleClick} />*/}
    </div>
  );
};

export default WorkspaceBanner;
